import { Transaccion } from '../types';

/** categoriaId de los adelantos: no pertenecen a ninguna categoría real. */
export const CATEGORIA_ADELANTO = '__adelanto__';

/**
 * ¿Cuenta esta transacción como ingreso/gasto real?
 * Los movimientos de traspaso y los adelantos solo mueven saldo entre cuentas
 * o personas, así que quedan fuera de totales, informes y gráficos.
 */
export const computa = (t: Transaccion) => !t.traspasoId && !t.adelanto;

export const SIN_PERSONA = 'Sin indicar';

/** Nombre de la persona de un adelanto, sin espacios sobrantes. */
export const personaDe = (t: Transaccion) => t.persona?.trim() || SIN_PERSONA;

/** Personas usadas en adelantos, para sugerirlas al escribir. */
export const personasDeAdelantos = (transacciones: Transaccion[]) => {
  const vistas = new Map<string, string>();
  transacciones.forEach(t => {
    const p = t.adelanto && t.persona?.trim();
    if (p && !vistas.has(p.toLowerCase())) vistas.set(p.toLowerCase(), p);
  });
  return Array.from(vistas.values()).sort((a, b) => a.localeCompare(b, 'es'));
};

/** ¿Es un adelanto (o devolución) de esta persona? Sin distinguir mayúsculas. */
export const esAdelantoDe = (t: Transaccion, persona: string) =>
  !!t.adelanto && personaDe(t).toLowerCase() === persona.trim().toLowerCase();

/**
 * Lo que te debe cada persona por adelantos: lo que pagaste por ella menos lo que
 * ya te ha devuelto. Negativo si te ha dado dinero por adelantado. Agrupa sin
 * distinguir mayúsculas, omite a quien ya está a cero y no cuenta los adelantos
 * saldados.
 */
export const pendientePorPersona = (transacciones: Transaccion[]) => {
  const saldos = new Map<string, { persona: string; importe: number }>();
  transacciones.filter(t => t.adelanto && !t.saldado).forEach(t => {
    const persona = personaDe(t);
    const clave = persona.toLowerCase();
    const actual = saldos.get(clave) ?? { persona, importe: 0 };
    actual.importe += t.tipo === 'gasto' ? t.cantidad : -t.cantidad;
    saldos.set(clave, actual);
  });
  return Array.from(saldos.values())
    .filter(s => Math.abs(s.importe) >= 0.005)
    .sort((a, b) => b.importe - a.importe);
};
